import { PLATFORMS_CODES } from '@/constants/languages'
import { IOriginal } from '@/types/shotlist.interface'
import type { TPlatformValue } from '@/types/uploadForm.interface'

export const getTranslationId = ({
	languages,
	selectedPlatform
}: {
	languages: IOriginal[]
	selectedPlatform: TPlatformValue | null
}) => {
	if (!languages || !selectedPlatform) return null

	return (
		languages.find(lang => lang.language === PLATFORMS_CODES[selectedPlatform])
			?.id || null
	)
}
